import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { ChangePassword } from "../../../@types/auth";
import axiosInstance from "../../../api/manageServer";

interface ChangePasswordState {
  isLoading: boolean;
  error: string | false;
  tokenType: string;
  changePassword: any;
  token: string | null;
}

const initialState: ChangePasswordState = {
  isLoading: false,
  error: false,
  tokenType: "Bearer",
  changePassword: null,
  token: null,
};

const slice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    changePasswordSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.changePassword = action.payload;
      state.token = action.payload.token || null;
    },
    changePasswordFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Export the reducer
export default slice.reducer;

const { actions } = slice;

// Thunk action for changing password
export function AuthChangePassword(changePassword: ChangePassword) {
  // console.log(changePassword)
  return async (dispatch: any, getState: any) => {
    dispatch(actions.startLoading());

    const token = localStorage.getItem("authToken");

    try {
      const response = await axiosInstance.put(
        "/auth/changePassword",
        changePassword,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("jjjjjjjjjjjjjjjjjjjjjj", response.data);
      // Check if the response contains data
      if (response?.data?.success) {
        dispatch(actions.changePasswordSuccess(response.data));
        toast.success(
          response?.data?.message || "Password changed successfully!"
        );
      } else {
        toast.error(response?.data?.message);
      }
      return response.data;
    } 
    catch (error: any) {
      // Extract error message, if possible
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";

      dispatch(actions.changePasswordFailure(errorMessage));
      toast.error(errorMessage);
    }
  };
}
